export default __webpack_public_path__ + "static/media/vestrotrim-image.91e115f0.jpg";